import BaseService from "@services/BaseService";

export default class LedgerService extends BaseService {
  entity = "ledgers";
}

export const ledgerService = new LedgerService();
